module.exports = __webpack_public_path__ + "img/img18.d1a794f1.png";